import { state } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { QueryProcessorService } from 'src/app/services/query-services/query-processor.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ApiserviceService } from 'src/app/Service/apiservice.service';
import { ObjectController } from 'src/app/services/object-controller/objectcontroller.service';
import { StandardUIService } from 'src/app/services/standardui-service/standardui-service';
import { debounceTime } from 'rxjs';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';



@Component({
  selector: 'app-address-dialog',
  templateUrl: './address-dialog.component.html',
  styleUrls: ['./address-dialog.component.scss']
})
export class AddressDialogComponent {
  @ViewChild('phoneNumberInput') phoneNumberInput!: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource = new MatTableDataSource<any>();

  displayedColumns = [
    {
      "id": "#",
      "displayName": "id"
    },
    {
      "id": "First Name",
      "displayName": "First Name"
    },
    {
      "id": "Last Name",
      "displayName": "Last Name"
    },
    {
      "id": "Phone Number",
      "displayName": "Phone Number"
    },
    {
      "id": "Email Address",
      "displayName": "Email"
    },
    {
      "id": "Address Line 1",
      "displayName": "Mailing Address"
    }
  ];

  truncateAddress(address: string): string {
    const maxLength = 20;
    if (address.length > maxLength) {
      return address.slice(0, maxLength) + '...';
    }
    return address;
  }

  // 'id',
  // 'firstName',
  // 'lastName',
  // 'phoneNumber',
  // 'email',
  // 'Mailing Address',
  // 'actions'
  pageSizeOptions: number[] = [5, 10, 25, 100];
  maxDate: string;
  dataerror: any;
  dataphonenumber:any
  constructor(public dialogRef: MatDialogRef<AddressDialogComponent>,
    private queryProcessorService: QueryProcessorService, private ss: StandardUIService, private fb: FormBuilder, private apiservice: ApiserviceService, private objectcontrolservice: ObjectController, private agentscriptservice: AgentscriptService_updated,@Inject(MAT_DIALOG_DATA) public data: any) {
    const today = new Date();
    this.maxDate = this.formatDate(today);
    // console.log(data.phonenumber)
    this.dataphonenumber=data?.phonenumber
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Build query `params` from new-contact form: drops keys with null, undefined, or blank values.
   * Phone numbers are sent digits-only (formatting stripped).
   */
  private newContactSearchParamsOmitEmpty(): Record<string, string> {
    const v = this.newcontact?.value;
    if (!v) {
      return {};
    }
    const raw: Record<string, unknown> = {
      lastname: v.lastname,
      firstname: v.firstname,
      phonenumber: v.phonenumber,
      email: v.email,
      street: v.street,
    };
    const out: [string, string][] = [];
    for (const [key, val] of Object.entries(raw)) {
      if (val == null) {
        continue;
      }
      let s = String(val).trim();
      if (s === '') {
        continue;
      }
      if (key === 'phonenumber') {
        s = s.replace(/\D/g, '');
        if (s === '') {
          continue;
        }
      }
      out.push([key, s]);
    }
    return Object.fromEntries(out) as Record<string, string>;
  }

  /** Trims string values in query `params` (shallow); drops keys whose trimmed value is an empty string. */
  private trimStringValuesInObject(obj: Record<string, unknown>): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      if (typeof v === 'string') {
        const t = v.trim();
        if (t === '') {
          continue;
        }
        out[k] = t;
      } else {
        out[k] = v;
      }
    }
    return out;
  }





  myGroup: FormGroup;
  newcontact: FormGroup;
  tab_title: any;

  customNameValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (value && value.toLowerCase().includes('anonymous')) {
      return { 'invalidName': true };
    }
    return null;
  }


  ngAfterViewInit() {
    // for genesys
    // const inputEvent = new Event('input', { bubbles: true });
    // const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
    // phoneNumberInput.dispatchEvent(inputEvent);

    // if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData)
    // {
    //   const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
    // console.log(phoneNumberInput.value)
    // this.phonenumber=phoneNumberInput.value
    //   this.search({ queryId: '23', offset: 0, params: { 'phonenumber': this.phonenumber } })
    // }
  }

  hidemessage() {
    this.dataSource.filteredData = []
    // console.log(this.dataSource.filteredData)
  }
  loadingImage:boolean = false;
  datatablepagination() {
    this.loadingImage = true;
    $("#contactlisttable_wrapper").remove();

    setTimeout(() => {
      ($('#contactlisttable') as any).dataTable({

        // "language": {
        //   "paginate": {
        //     "previous": "",
        //     "next": ""
        //   },
        //   "lengthMenu": "Records per page _MENU_",
        // },
        pageLength: this.perPage,
        "order": [[2, "asc"]],

        "columnDefs": [
          { "orderable": false, "targets": 0 },
          // { "orderable": false, "targets": 1 },
          { 'orderable': false, 'targets': 6 }
        ],

        // "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
          fixedColumns: {
            start: 2,
            end: 1
        },
        paging: true,
        fixedHeader: true,
        // scrollX: false,
        scrollY: 400,
        destroy:true,
        // dom: 'frtlip',
        dom: 'frt',
        drawCallback: function (settings) {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let startIndex = api.page() * api.page.len() + 1;

          $(rows).each(function (index) {
            $('td', this).eq(0).html(startIndex.toString()); // Convert to string before setting as HTML content
            startIndex++;
          });
        },
      },200);
      this.loadingImage = false;
    });
    this.datatableload=true

  }
  datatableload:boolean=true

  offset = 0;
  perPage = 100;
  pageNo = 1;
  onset=this.perPage
   prev() {
    console.log(this.offset);
    console.log(this.pageNo);
    if (this.offset > 0) {
      this.offset = this.offset - this.perPage;
      this.pageNo--;
      this.onset=this.pageNo*this.perPage
      // alert(this.offset)

    // this.datatableload=false
      this.search({queryId: '23', offset: this.offset,perpage:this.perPage})
    }
  }
   next() {
    if (true) {
      this.offset = this.offset + this.perPage;
      //console.log(this.offset)
      this.pageNo++;
      this.onset=this.pageNo*this.perPage
      // alert(this.offset)
    // this.datatableload=false
      this.search({queryId: '23', offset: this.offset,perpage:this.perPage})
    }
  }
  perPagechange()
  {
    this.pageNo=1
    // this.datatableload=false
    this.search({queryId: '23', offset: 0,perpage:this.perPage})
  }

  emailValidator(group: FormGroup) {
    const emailValue = group.get('email').value;
    // console.log(emailValue)
    if (!(emailValue == null || emailValue == '' || emailValue == undefined))
      {
        // console.log("not empty")
    // return (control: AbstractControl): { [key: string]: any } | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      // const emailValue = control.value;

      if (!emailValue || emailPattern.test(emailValue)) {
        return null; // Valid email format
      } else {
        // console.log("email is invalid")
        group.get('email').setErrors({ invalidEmail: true });
        // return { invalidEmail: true }; // Invalid email format
      }
    // };
      }
      else
      {
        group.get('email').setErrors(null);
        return null;
      }
      // console.log(this.newcontact.get('email').invalid)


  }

  ngOnInit(): void {

    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    console.log("hi")
    this.myGroup = this.fb.group({
      lastname: ['', Validators.required],
      firstname: ['', Validators.required],
      phonenumber: ['', Validators.required],
      // phonenumber2: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      // emailalt1: ['', [Validators.required, Validators.email]],
      postalcode: ['', Validators.required],
      street: [''],
      city: [''],
      stateprovience: [''],
      country: ['']

    });
    this.newcontact = this.fb.group({
      // nametype: [],
      nameprefix: [],
      firstname: ['', [Validators.required, this.customNameValidator]],
      namemiddle: [],
      lastname: ['', [Validators.required, this.customNameValidator]],
      namesuffix: [],
      phonenumber: ['', [Validators.minLength(14)]],
      alternateph: [''],
      language: [],
      email: [''],
      emailalt1: [''],
      dob: [],
      companyname: [],
      street: [''],
      city: [''],
      stateprovience: [''],
      postalcode: [''],
      country: ['']
    },{ validator: this.emailValidator });
    console.log(this.apiservice.gensysdata)
    this.picklist();

    if(this.dataphonenumber.length >= 10)
      {
        this.myGroup.get('phonenumber')?.setValue(this.formatPhoneNumber(this.dataphonenumber));
      this.newcontact.get('phonenumber')?.setValue(this.formatPhoneNumber(this.dataphonenumber));

      // this.myGroup.get('phonenumber')?.setValue(this.dataphonenumber);
      // this.newcontact.get('phonenumber')?.setValue(this.dataphonenumber);
      // console.log(this.dataphonenumber)

      setTimeout(() => {
        this.search({ queryId: '23', offset: 0, params: { 'phonenumber': this.dataphonenumber } })

      }, 1000);
      }

    // this.newcontact.get('firstname').valueChanges.subscribe(() => {
    //   this.checkFormAndTriggerAction();
    // });

    // this.newcontact.get('lastname').valueChanges.subscribe(() => {
    //   this.checkFormAndTriggerAction();
    // });

    // this.newcontact.get('email').valueChanges.subscribe(() => {
    //   this.checkFormAndTriggerAction();
    // });


    // .pipe(
    //   // debounceTime(10) // Adjust the debounce time as needed (in milliseconds)
    // )


    // this.myGroup.get('phonenumber')?.patchValue('+17654909576');

    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
      // Assign the firstname value from geneSysData to the corresponding form control
      console.log(this.apiservice.gensysdata)
      console.log(this.myGroup.value.Phone)
      this.phonenumber = this.apiservice.gensysdata.geneSysData.phonenumber;
      const name = this.apiservice.gensysdata.geneSysData.firstname;

      // this.myGroup.get('Phone')?.setValue(this.apiservice.gensysdata.geneSysData.phonenumber);
      // if (name) {
      //   const nameParts = name.split(' ');

      //   // Set first name and last name
      //   if (nameParts.length > 1) {
      //     this.myGroup.get('firstname')?.setValue(nameParts[0]);
      //     this.myGroup.get('lastname')?.setValue(nameParts.slice(1).join(' '));
      //   } else {
      //     this.myGroup.get('firstname')?.setValue(name);
      //   }
      // }

      // commented the code
      // this.myGroup.get('phonenumber')?.setValue(this.formatPhoneNumber(this.apiservice.gensysdata.geneSysData.phonenumber));
      // this.newcontact.get('phonenumber')?.setValue(this.formatPhoneNumber(this.apiservice.gensysdata.geneSysData.phonenumber));
      // console.log(this.phonenumber)

      // setTimeout(() => {
      //   this.search({ queryId: '23', offset: 0, params: { 'phonenumber': this.phonenumber } })

      // }, 1000);
    }
  }
  states: any = [];
  country: any[];
  nametypearray: any = [];
  defaultCountryCode = "IN";
  selected: any;
  selectedcountry: any;
  picklistcountry: any;
  pickliststate: any;
  // Assuming this is inside a component class
  // isAnyFieldNull(): boolean {
  //   const controls = this.myGroup.controls;

  //   for (const controlName in controls) {
  //     if (controls.hasOwnProperty(controlName)) {
  //       const control = controls[controlName];
  //       if (control.value === null) {
  //         return true;
  //       }
  //     }
  //   }
  //   return false;
  // }

  clearcontactsearch()
  {
    this.showContactAlreadyExistsMessage = false;
    var phonenumber=this.myGroup.get('phonenumber')?.value

    // this.myGroup.get('lastname')?.setValue("")
    // this.myGroup.get('firstname')?.setValue("")
    // this.myGroup.get('email')?.setValue("")
    // this.myGroup.get('street')?.setValue("")
    this.myGroup.reset()
    this.myGroup.get('phonenumber')?.setValue(phonenumber)

  }
  clearnewcontact()
  {
    var phonenumber=this.newcontact.get('phonenumber')?.value
    this.newcontact.reset()
    this.newcontact.get('phonenumber')?.setValue(phonenumber)

  }


  checkFormAndTriggerAction() {
    let params1: any = {
      'lastname': this.newcontact.value.lastname,
      'firstname': this.newcontact.value.firstname,
      'email': this.newcontact.value.email,
    }
    if (this.newcontact.value.lastname && this.newcontact.value.firstname && this.newcontact.value.email) {
      // this.search({queryId: '23',offset: 0,params: params1});

      this.subscription = this.queryProcessorService.searchQueriesService({ queryId: '23', offset: 0, params: params1 }).subscribe(data => {
        //console.log('saved query');
        // this.loading = false;

        console.log(data);
        this.jsonData = data;
        this.duplicatecontact = data;


        this.dataSource = new MatTableDataSource(data.rows)
        console.log(this.dataSource.filteredData.length)

        this.dataSource.paginator = this.paginator;

        console.log(data.rows.length)

        // if (data.rows.length == 1 && !this.showNewContactSection) {
        //   this.loadaddressview(data.rows[0])
        // }
      })

    }

    this.dataSource.data = [];
    // // Check if all required fields are filled
    // if (firstName && lastName && email) {
    //   // console.log("hyy")
    //   // Trigger your action here
    //   // this.yourAction();
    // }
  }
  picklist() {
    const picklistIDs = [114, 115, 103]; // Array of picklist IDs

    picklistIDs.forEach(picklistID => {
      this.ss.getPicklistByID(picklistID).subscribe(data => {
        const picklistValues = [];
        for (let key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({
              "key": data[key].id,
              "value": data[key].valueen
            });
          }
        }
        if (picklistID == 114) {
          // Store values for picklist ID 114 in one array
          this.states.push(...picklistValues);
          console.log(this.states)
          let targetValue = 'United States (US)';
          let targetObject = null;

          for (let i = 0; i < this.states.length; i++) {
            if (this.states[i].value === targetValue) {
              targetObject = this.states[i];
              break; // Stop searching once found
            }
          }
          // targetObject=this.selected;
          // console.log(this.selected)

          // Now targetObject contains the object with value 'DC', you can access its properties if needed
          console.log(targetObject.value);
          this.selectedcountry = targetObject.value;
          this.picklistcountry = targetObject.value;
          console.log(this.selectedcountry)
        } else if (picklistID == 115) {
          // Store values for picklist ID 115 in a separate array
          if (!this.country) {
            this.country = [];
          }
          // Store values for picklist ID 115 in a separate array
          this.country.push(...picklistValues);
          let targetValue = 'IN';
          let targetObject = null;

          for (let i = 0; i < this.country.length; i++) {
            if (this.country[i].value === targetValue) {
              targetObject = this.country[i];
              break; // Stop searching once found
            }
          }
          // targetObject=this.selected;
          // console.log(this.selected)

          // Now targetObject contains the object with value 'DC', you can access its properties if needed
          console.log(targetObject.value);
          this.selected = targetObject.value;
          this.pickliststate = targetObject.value;
          // console.log(this.selected)
          // console.log(this.country)
        }
        else if (picklistID == 103) {

          this.nametypearray.push(...picklistValues);
          console.log(this.nametypearray)
        }

      });
    });


  }

  showContactErrorMessage:boolean=false;
  /** Shown on contact search when user tried to create a contact that already exists */
  showContactAlreadyExistsMessage = false;

  onSubmit() {
    this.showContactErrorMessage=false
    this.showContactAlreadyExistsMessage = false;
    console.log("in submit")
    console.log(this.states)
    console.log(this.newcontact.value.stateprovience)
    console.log(this.country.find(state => state.value === this.newcontact.value.stateprovience)?.key)
    let state = this.country.find(state => state.value === this.newcontact.value.stateprovience)?.key;
    let country = this.states.find(country => country.value === this.newcontact.value.country)?.key;
    console.log(state, country)
    // console.log(parseInt(this.newcontact.value.nametype));

    var addressid = (this.newcontact.value.street ? this.newcontact.value.street + ' \n' : '') + (this.newcontact.value.city ? this.newcontact.value.city + ' ' : '') + (this.newcontact.value.stateprovience ? this.newcontact.value.stateprovience + ' ' : '') + (this.newcontact.value.postalcode ? this.newcontact.value.postalcode : '')
    console.log(addressid)
    console.log(addressid + (this.newcontact.value.country?this.newcontact.value.country:''))
    let contactPayload: any = {
      // 'Contact.nametype': parseInt(this.newcontact.value.nametype),
      'Contact.nameprefix': this.newcontact.value.nameprefix,
      'Contact.namemiddle': this.newcontact.value.namemiddle,
      'Contact.namesuffix': this.newcontact.value.namesuffix,
      'Contact.language': this.newcontact.value.language,
      'Contact.dob': this.newcontact.value.dob,
      'Contact.companyname': this.newcontact.value.companyname,
      'Contact.lastname': this.newcontact.value.lastname,
      'Contact.firstname': this.newcontact.value.firstname,
      'Contact.phonenumber': this.newcontact.value.phonenumber,
      'Contact.alternateph': this.newcontact.value.alternateph,
      'Contact.email': this.newcontact.value.email,
      'Contact.emailalt1': this.newcontact.value.emailalt1,
      'Contact.postalcode': this.newcontact.value.postalcode,
      // 'Contact.providenceid': state,
      // 'Contact.countryid': country,
      'Contact.street': this.newcontact.value.street,
      'Contact.city': this.newcontact.value.city,
      'Contact.addressid': addressid,
      "Contact.countryid":1,
      "Contact.providenceid":19
      //  + this.newcontact.value.country ? this.newcontact.value.country :'',
    };
    var contactPayloadfilter = Object.fromEntries(
      Object.entries(contactPayload).filter(([key, value]) => value !== "" && value != null)
    );

    let contactPayloadArray =
      { entityName: 'Contact', payLoad: contactPayloadfilter }
    ;


    console.log(contactPayloadArray);
    console.log(this.showNewContactSection)
    const params1 = this.newContactSearchParamsOmitEmpty();

    if (this.newcontact.value.lastname && this.newcontact.value.firstname) {
      // this.search({queryId: '23',offset: 0,params: params1});

      this.subscription = this.queryProcessorService.searchQueriesService({ queryId: '23', offset: 0, params: params1 }).subscribe(data => {
        //console.log('saved query');
        // this.loading = false;

        console.log(data);
        this.jsonData = data;
        this.duplicatecontact = data;


        this.dataSource = new MatTableDataSource(data.rows)
        console.log(this.dataSource.filteredData.length)

        this.dataSource.paginator = this.paginator;

        console.log(data.rows.length)

        if (data.rows.length == 0) {
          console.log(contactPayloadArray)
          // return false
          // this.jsonData=this
          // Call your service to save the contact payload
          // commented code
          // this.objectcontrolservice.createContact(contactPayloadArray).subscribe((data: any) => {
            this.objectcontrolservice.entityCreate(contactPayloadArray).subscribe((data: any) => {
            console.log(data);
            this.dataerror= data.error;
           console.log(this.dataerror);
            console.log(data.Contact)
            // let params: any;
            // params=this.newcontact.value;
            let params = {
              // other fields from the form
              lastname: this.newcontact.value.lastname,
              firstname: this.newcontact.value.firstname,
              phonenumber: this.newcontact.value.phonenumber,
              // phonenumber2: this.newcontact.value.phonenumber2,
              email: this.newcontact.value.email,
              // emailalt1: this.newcontact.value.emailalt1,
              // postalcode: this.newcontact.value.postalcode,
              // street: this.newcontact.value.street,
              // city: this.newcontact.value.city,
              // providenceid: state,
              // country: country,
              // nametype:parseInt(this.newcontact.value.nametype),
              // nameprefix:this.newcontact.value.nameprefix,
              // namemiddle:this.newcontact.value.namemiddle,
              // namesuffix:this.newcontact.value.namesuffix,
              // language:this.newcontact.value.language,
              // dob:this.newcontact.value.dob,
              // companyname:this.newcontact.value.companyname,
            };
            //   if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData)
            // {
            //   const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
            // console.log(phoneNumberInput.value)
            // this.phonenumber=phoneNumberInput.value
            //   params['phonenumber']=phoneNumberInput.value
            // }
            var filteredData = Object.fromEntries(
              Object.entries(params).filter(([key, value]) => value !== "" && value != null)
            );
            console.log(filteredData)

            console.log(params)
            console.log(params)
            if(this.dataerror===null)
              {
                // this.dataphonenumber=params?.phonenumber
                this.myGroup.reset()
                if (!(params?.phonenumber == null || params?.phonenumber == '' || params?.phonenumber == undefined)) {
                  this.myGroup.get('phonenumber')?.setValue(params?.phonenumber);
                }
                if (!(params?.firstname == null || params?.firstname == '' || params?.firstname == undefined)) {
                  this.myGroup.get('firstname')?.setValue(params?.firstname);
                }
                if (!(params?.lastname == null || params?.lastname == '' || params?.lastname == undefined)) {
                  this.myGroup.get('lastname')?.setValue(params?.lastname);
                }
                if (!(params?.email == null || params?.email == '' || params?.email == undefined)) {
                  this.myGroup.get('email')?.setValue(params?.email);
                }
                this.showNewContactSection = false;
                this.showContactErrorMessage = false;
                this.showContactAlreadyExistsMessage = false;
                this.showSuccessMessage = true;
                console.log("in if")
                this.search({
                  queryId: '23',
                  offset: 0,
                  perpage: 1,
                  params:filteredData
                });

              }
              else {
                console.log("in else")
                // Display a message indicating that the record is already present
                this.showContactErrorMessage = true;
                this.showNewContactSection=true;
                this.newcontact.reset(); // Assuming you have a variable to control the visibility of the message
            }




            // Handle response if needed
          });
        }

        else {
          // Contact already exists: go back to contact search view (same as after creating new contact)
          const params = this.newContactSearchParamsOmitEmpty();
          const filteredData = params;
          this.myGroup.reset();
          if (!(params?.phonenumber == null || params?.phonenumber == '' || params?.phonenumber == undefined)) {
            this.myGroup.get('phonenumber')?.setValue(params?.phonenumber);
          }
          if (!(params?.firstname == null || params?.firstname == '' || params?.firstname == undefined)) {
            this.myGroup.get('firstname')?.setValue(params?.firstname);
          }
          if (!(params?.lastname == null || params?.lastname == '' || params?.lastname == undefined)) {
            this.myGroup.get('lastname')?.setValue(params?.lastname);
          }
          if (!(params?.email == null || params?.email == '' || params?.email == undefined)) {
            this.myGroup.get('email')?.setValue(params?.email);
          }
          this.showNewContactSection = false;
          this.showContactErrorMessage = false;
          this.showSuccessMessage = false;
          this.search({
            queryId: '23',
            offset: 0,
            perpage: 100,
            params: filteredData,
            _showContactAlreadyExistsAfterSearch: true
          });
        }

      })

    }



  }


  closepopup(data: any) {

    this.dialogRef.close(data);
  }

  subscription: any;
  jsonData: any;
  phonenumber: any;
  duplicatecontact: any;
  showSuccessMessage: boolean = false;

  getcolumnvalues(id: any) {
    const index = this.rowcolumns.findIndex(column => column == id);
    // console.log(index);
    return index;
  }

  getPhonenumber() {

    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
      const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
      console.log(phoneNumberInput.value)
      this.phonenumber = phoneNumberInput.value
      return phoneNumberInput.value
    }
    return 0

  }
  rowcolumns: any
  rowdata: any=[]
  search(payload: any) {    
    this.datatableload=false
    const showAlreadyExistsAfterSearch = payload._showContactAlreadyExistsAfterSearch === true;
    if (Object.prototype.hasOwnProperty.call(payload, '_showContactAlreadyExistsAfterSearch')) {
      delete payload._showContactAlreadyExistsAfterSearch;
    }
    if (!showAlreadyExistsAfterSearch) {
      this.showContactAlreadyExistsMessage = false;
    }
    // this.offset=payload.offset
    // this.perPage=payload.perPage
    console.log(this.myGroup)


    // return false
    console.log(payload)
    console.log(this.myGroup.value.firstname);
    console.log(this.phonenumber)
    console.log("in search")
    // payload.params = {'firstname': this.myGroup.value.firstname,'lastname': this.myGroup.value.lastname,'Phonenumber': this.myGroup.value.Phone,'Email': this.myGroup.value.Email,
    // 'Postal': this.myGroup.value.Postal,'Address': this.myGroup.value.Address,'companyname': this.myGroup.value.companyname };
    console.log(this.showNewContactSection)
    if (this.showNewContactSection == true) {


      this.myGroup.reset();
      // return;

    }
    if (this.showNewContactSection == false) {
      let params: any = {};
      console.log()

      // Iterate through form controls
      for (const controlName in this.myGroup.controls) {
        if (this.myGroup.controls.hasOwnProperty(controlName)) {
          const control = this.myGroup.controls[controlName];
          // Check if control has value
          if (control.value) {
            if(controlName == 'phonenumber')
              {
                // alert()
                params[controlName] = control.value.replace(/[^0-9]/g, '')
              }
              else if(controlName == 'street')
                {
                  params[controlName] = control.value.replaceAll(/[^a-zA-Z0-9]/g, '');
                }
              else
              {
            // Add control value to params object
            params[controlName] = control.value;
              }

          }
        }
      }

      // Find the key for the selected state/province
      let state = this.country?.find(state => state.value === this.myGroup.value.stateprovience)?.key;

      // Find the key for the selected country
      let country = this.states?.find(country => country.value === this.myGroup.value.country)?.key;

      // Assign state and country to params
      params['stateprovience'] = state;
      params['country'] = country;

      // Now params contains all the form values including state and country keys
      console.log(params);



      // if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData)
      // {
      //   const phoneNumberInput = document.getElementById('phonenumber') as HTMLInputElement;
      // console.log(phoneNumberInput.value)
      // this.phonenumber=phoneNumberInput.value
      //   params['phonenumber']=phoneNumberInput.value
      // }
      console.log(params)
      payload.params = params;
    }

    if (payload.params && typeof payload.params === 'object') {
      payload.params = this.trimStringValuesInObject(payload.params as Record<string, unknown>);
    }

    // // this.search(payload);
    console.log(payload)
    // alert(payload)
    this.subscription = this.queryProcessorService.searchQueriesService(payload).subscribe(data => {
      //console.log('saved query');
      // this.loading = false;

      console.log(data);
      this.jsonData = data;
      this.rowcolumns = data.cols
      this.duplicatecontact = data;

      this.rowdata = data.rows

      this.dataSource = new MatTableDataSource(data.rows)
      console.log(this.dataSource.filteredData.length)

      this.dataSource.paginator = this.paginator;

      console.log(data.rows.length)

      this.datatablepagination()
      if(data.rows.length == 0)
        {
          var asignpayload=this.filterEmptyValues(payload)
          Object.keys(asignpayload.params).forEach(key => {
            if (this.newcontact.contains(key)) {
              if(key=='street')
                {
                  this.newcontact.get(key).setValue(this.myGroup.get('street').value);
                }
                else
                {
                  this.newcontact.get(key).setValue(asignpayload.params[key]);
                }
            }
          });
          console.log(this.newcontact.value)
        }
        else
        {
          this.newcontact.reset()
        }
      if (showAlreadyExistsAfterSearch && data.rows && data.rows.length >= 1) {
        this.showContactAlreadyExistsMessage = true;
      }
      // if (data.rows.length == 1 && !this.showNewContactSection) {
      //   this.loadaddressview(data.rows[0])
      // }
    },
      error => {
        console.log('error in searchQueriesService');
        // this.submitted = false;
      });
    this.showSuccessMessage = false;


    // thi
  }

  filterEmptyValues(payload: any): any {
    const filteredPayload = { ...payload };
    for (const key in filteredPayload) {
      if (filteredPayload[key] == null || filteredPayload[key] === '') {
        delete filteredPayload[key];
      }
    }
    return filteredPayload;
  }

  showNewContactSection: boolean = false;
  showDataCondition: boolean = false;
  closeSuccessMessage() {
    this.showSuccessMessage = false;
  }

  closeContactAlreadyExistsMessage() {
    this.showContactAlreadyExistsMessage = false;
  }
  showdata() {
    // this.newcontact.reset()
    if(this.myGroup.get('phonenumber').value.length== 14)
      {
      this.newcontact.get('phonenumber')?.setValue(this.myGroup.get('phonenumber').value);
      }

    console.log(this.apiservice.gensysdata);
    if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {


      const name = this.apiservice.gensysdata.geneSysData.firstname;
      if (name) {
        const nameParts = name.split(' ');

        // Set first name and last name
        // commented as not needed
        // if (nameParts.length > 1) {
        //   this.newcontact.get('firstname')?.setValue(nameParts[0]);
        //   this.newcontact.get('lastname')?.setValue(nameParts.slice(1).join(' '));
        // } else {
        //   this.newcontact.get('firstname')?.setValue(name);
        // }
      }

      // Set phone number if available
      // commenting code
      // if (this.apiservice.gensysdata.geneSysData.phonenumber) {
      //   // Apply phone number formatting here
      //   // const formattedPhoneNumber = this.formatPhoneNumber(this.apiservice.gensysdata.geneSysData.phonenumber);
      //   // this.newcontact.get('phonenumber')?.setValue(this.formatPhoneNumber(this.apiservice.gensysdata.geneSysData.phonenumber));
      // }
      this.showDataCondition = true;
      this.newcontact.get('email')?.clearValidators();
      this.newcontact.get('email')?.updateValueAndValidity();
    } else {
      this.showDataCondition = false;
      // Restore email validator if the condition doesn't execute
      this.newcontact.get('email')?.setValidators([Validators.required, Validators.email]);
      this.newcontact.get('email')?.updateValueAndValidity();
    }
    // this.showSuccessMessage = true;
  }



  formatPhoneNumber(phoneNumber: string): string {
    if (phoneNumber.startsWith('+1')) {
      phoneNumber = phoneNumber.substring(2);
    }
    // Remove all non-numeric characters from the phone number
    const numericPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Apply the phone number format (XXX) XXX-XXXX
    const formattedPhoneNumber = numericPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    return formattedPhoneNumber;
  }
  // showAlert: boolean = true;
  toggleNewContactSection() {
    this.showNewContactSection = !this.showNewContactSection;
    this.entiredata = []
    this.addressSuggestions = [];
    this.showContactErrorMessage=false;
    this.showContactAlreadyExistsMessage = false;
    // this.showAlert = false;
    console.log(this.showNewContactSection)
    this.dataSource.data = [];
    console.log(this.dataSource.data)
    console.log(this.jsonData)
this.jsonData=[];
    // this.newcontact.reset();
  }
  loadaddressview(data: any) {
    this.apiservice.gensysdata=null;
    console.log(data)
    var data1:any=[]
    data1.rowdata=data
    data1.rowcolumns=this.rowcolumns

    this.closepopup(data1)
  }
  showWarningMessage: boolean = true;
  showJsonData() {
    // console.log(this.newcontact.get('phonenumber').value)
    if(this.newcontact.get('phonenumber')?.value && this.newcontact.get('phonenumber')?.value.length== 14)
      {
      this.myGroup.get('phonenumber')?.setValue(this.newcontact.get('phonenumber').value);
      }
    this.entiredata = []
    this.addressSuggestions = []
    this.showNewContactSection = false;
    // this.myGroup.reset();
    this.showWarningMessage = false;
    console.log(this.jsonData)
    this.jsonData=[];
  }
  // openModalPopup() {
  //   this.subscription = this.apiservice.getcontactdetails(this.apiservice.gensysdata.geneSysData.phonenumber).subscribe((data:any) => {
  //     console.log(this.apiservice.gensysdata.geneSysData.phonenumber)
  //     console.log(data);
  //     this.jsonData = data;
  //     this.dataSource = new MatTableDataSource(data)
  //     console.log(this.dataSource)
  //     this.dataSource.paginator = this.paginator;
  //   });
  // }
  entiredata: any;
  addressSuggestions: any;
  addressvalue: any;
  address: any;
  assignaddress(item: any) {

    this.addressSuggestions = []
    this.address = item.split(',')[0].trim();;
    this.myGroup.get('street')?.setValue(this.address)

    console.log(this.address)

  }
  suggestionSearch() {
    if (this.showNewContactSection == true) {
      this.addressvalue = this.newcontact?.get('street')?.value;
      // console.log(this.addressvalue)
    }
    else {
      this.addressvalue = this.myGroup?.get('street')?.value;
    }
    // console.log(this.addressvalue)
    // console.log(this.addressvalue.length)
    if(this.addressvalue!=null && this.addressvalue!=undefined && this.addressvalue.length>0)
      {
        // console.log("true")
      this.performAddressSearch(this.addressvalue)
      }
      else
      {
        // console.log("false")
        this.addressSuggestions=[]
      }

  }
  async performAddressSearch(searchTerm: any) {
    // console.log(searchTerm)
    this.agentscriptservice.mapsuggestions(searchTerm).subscribe((response: any) => {
      console.log(response.suggestions);
      this.entiredata = response.suggestions
      this.addressSuggestions = response.suggestions.map((suggestion: { text: any; }) => suggestion.text);
      console.log(this.addressSuggestions);
    });

  }
  @Output() childComponentValue = new EventEmitter<any>();

  fetchaddressdetails: any;
  assignAddress(item: any) {
    this.addressSuggestions = []
    var streetAddress = item.split(',')[0].trim();
    console.log(item)
    // this.selectedmap=$('.pane:visible [data-basemap-id]').attr('data-basemap-id')
    // this.togglemap=
    // console.log(this.selectedmap)
    // console.log($('[data-basemap-id]').attr('data-basemap-id'))
    this.addressvalue = item
    // this.suggestionSearch()

    //   var k=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
    // let casetypeid = k.serviceDetails.casetypeid;
    //   console.log(k.serviceDetails.casetypeid)
    this.agentscriptservice.fetchaddressdetails(streetAddress, 'Address', '').subscribe((data: any) => {
      this.fetchaddressdetails = data
      this.agentscriptservice.updateOrInsertArray(this.tab_title, 'mapdata', this.fetchaddressdetails)
      console.log(this.fetchaddressdetails)
      if (this.fetchaddressdetails.msg) {
        // alert("please enter valid address")
        Swal.fire({
          title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >please enter valid address</div></div>',
          icon: 'error',
          imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
imageHeight: 45,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: `OK`,
          cancelButtonText: 'Cancel'
        })
      }
      else {
        this.agentscriptservice.locationcoordinates = this.fetchaddressdetails

        const coords = {
          // msr_addresstype:this.fetchaddressdetails?.address_type,
          // msr_serviceaddress:this.fetchaddressdetails?.returned_address,
          msr_city: 'FORT WAYNE',
          msr_state: 'IN',
          msr_zip: this.fetchaddressdetails?.personal_data.property_address_zip ? this.fetchaddressdetails?.personal_data.property_address_zip : '46802',
          msr_serviceaddress: this.fetchaddressdetails?.returned_address,
          // msr_withinlimits: this.fetchaddressdetails?.address_details.within_limits,
          // msr_recycleweek:this.fetchaddressdetails?.address_details.recycle_week_ID,
          // msr_collectionday:this.fetchaddressdetails?.address_details.collection_day,
          // msr_jurisdiction:this.fetchaddressdetails?.address_details.jurisdiction,
          // msr_next_collection_day:this.fetchaddressdetails?.address_details.next_collection_day,
          // msr_zoning:this.fetchaddressdetails?.address_details.zoning_id,
          // msr_lat: this.fetchaddressdetails?.lat,
          // msr_lng: this.fetchaddressdetails?.lng,
          // msr_parcelnumber: this.fetchaddressdetails?.personal_data.parcel_number,
          // msr_nearbyIncidents:this.fetchaddressdetails?.nearby_incidents
          // msr_parcelnumber: this.fetchaddressdetails.personal_data.parcel_number,
        };
        console.log(coords)

        // this.agentscriptservice.isGisVerified=true;
        this.childComponentValue.emit(coords);
        const matchedOption = this.country.find(option => option.value === coords.msr_state);

        // Set the value of the form control 'stateprovience'
        if (matchedOption) {
          console.log(matchedOption)
          this.newcontact.get('stateprovience')?.setValue(matchedOption.value);
        }
        this.newcontact.get('street')?.setValue(coords.msr_serviceaddress)
        this.newcontact.get('city')?.setValue(coords.msr_city)
        // this.newcontact.get('stateprovience')?.setValue(coords.msr_state)
        // console.log(this.newcontact.get('stateprovience')?.setValue(coords.msr_state))
        this.newcontact.get('postalcode')?.setValue(coords.msr_zip)
        // this.newcontact.get('country')?.setValue("United ")


        // this.geocodeAndCenter(streetAddress)
      }




    })

  }
}
